/**
 * Streams SSE responses reliably — buffers partial lines across chunks so a
 * `data: {...}` payload split by TCP/HTTP2 fragmentation is never dropped.
 *
 * Usage:
 *   for await (const ev of readSseLines(response)) {
 *       if (ev.type === "delta") ...
 *   }
 */
export async function* readSseLines(response) {
    if (!response.ok || !response.body) {
        throw new Error(`HTTP ${response.status}`);
    }
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buf = "";
    while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buf += decoder.decode(value, { stream: true });
        let idx;
        while ((idx = buf.indexOf("\n")) >= 0) {
            const line = buf.slice(0, idx);
            buf = buf.slice(idx + 1);
            if (!line.startsWith("data: ")) continue;
            const raw = line.slice(6).trim();
            if (!raw) continue;
            try {
                yield JSON.parse(raw);
            } catch {
                // Keep-alive comments or partial JSON — safe to ignore.
            }
        }
    }
    // Flush any final line that didn't end in \n.
    if (buf.startsWith("data: ")) {
        const raw = buf.slice(6).trim();
        if (raw) {
            try { yield JSON.parse(raw); } catch { /* ignore */ }
        }
    }
}
